import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const TurnOnFlipperFeature = new ReduxAsyncAction<'FLIPPER_TURN_ON_FEATURE', string, string>('FLIPPER_TURN_ON_FEATURE');

TurnOnFlipperFeature.registerRequest(async (feature) => {
  await dash_api.post('/v1/flipper/turn-on-feature', { feature });

  return feature;
});

export const FLIPPER_ON = TurnOnFlipperFeature.actionNamespaceConstants;

export const turnOnFlipperFeature = TurnOnFlipperFeature.request;

export type TurnOnFlipperFeatureResponseAction = Action<typeof FLIPPER_ON.response> & { data: string };
